<template>
  <template />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, onBeforeUnmount, watch } from 'vue'
import { ResponsiveState } from '@/types/store/base'
import { useStore } from '@/store/index'
import { debounce } from 'lodash'

// https://tailwindcss.com/docs/responsive-design
const SM_WIDTH = 640
const MD_WIDTH = 768
const LG_WIDTH = 1024
const XL_WIDTH = 1280

export default defineComponent({
  setup() {
    const store = useStore()
    const nowWidth = ref()
    const SPEED = 300
    const setNowWidth = () => {
      nowWidth.value = window.innerWidth
    }

    const handleResize = debounce(setNowWidth, SPEED)

    watch(nowWidth, () => {
      const responsive: ResponsiveState = {
        isSM: (nowWidth.value < SM_WIDTH),
        isMD: (nowWidth.value < MD_WIDTH),
        isLG: (nowWidth.value < LG_WIDTH),
        isXL: (nowWidth.value < XL_WIDTH)
      }
      store.commit('base/setResponsive', responsive)
    })

    onMounted(() => {
      setNowWidth()
      window.addEventListener('resize', handleResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })
  },
})
</script>
